import { getSegmentDomains } from '@ui/one-trust/dist/segment-wiring-utils'

export default {
  init (segmentKey, noLoad) {
    window.analytics = window.analytics || []

    // If the real analytics.js is already on the page return or the snippet was invoked already.
    if (window.analytics.initialize || window.analytics.invoked) {
      return
    } else {
      window.analytics.invoked = true
    }

    window.analytics.methods = [
      'trackSubmit',
      'trackClick',
      'trackLink',
      'trackForm',
      'pageview',
      'identify',
      'reset',
      'group',
      'track',
      'ready',
      'alias',
      'debug',
      'page',
      'once',
      'off',
      'on',
      'addSourceMiddleware',
      'addIntegrationMiddleware',
      'setAnonymousId',
      'addDestinationMiddleware'
    ]

    window.analytics.factory = function (method) {
      return function () {
        const args = Array.prototype.slice.call(arguments)
        args.unshift(method)
        window.analytics.push(args)
        return window.analytics
      }
    }

    for (let i = 0; i < window.analytics.methods.length; i++) {
      const key = window.analytics.methods[i]
      window.analytics[key] = window.analytics.factory(key)
    }

    window.analytics.load = function (key, options) {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.setAttribute('data-ot-ignore', '')

      const { segmentCdnDomain } = getSegmentDomains()
      const protocol = document.location.protocol === 'https:' ? 'https://' : 'http://'
      script.src = `${protocol}${segmentCdnDomain}/analytics.js/v1/${key}/analytics.min.js`

      const first = document.getElementsByTagName('script')[0]
      first.parentNode.insertBefore(script, first)
      window.analytics._loadOptions = options
    }

    window.analytics.SNIPPET_VERSION = '4.15.3'

    // On Zava, the consent manager will start segment
    if (window.siteInfo.site !== 'zava' && window.siteInfo.site !== 'tosca' && !noLoad) {
      window.analytics.load(segmentKey)
    }

    this.addHotjarMiddleWare()
  },
  identify (userId = null, traits = null, options = {}) {
    window.analytics.identify(userId, traits, {
      ...options
    })
  },
  viewPage ({ title, options }) {
    let referrer
    const referrerStore = window.sessionStorage.getItem('referrer')

    // the referrer held in sessionStorage persists across CMS pages when navigating away from '/account' to any CMS page, so instead we use 'document.referrer', except in the case when we can verify that we are still in '/account' section.
    if (referrerStore && document.referrer.includes('/account')) {
      referrer = referrerStore
    } else {
      referrer = document.referrer
    }
    if (!options) {
      window.analytics.page(title, { referrer: referrer })
    } else {
      window.analytics.page(title, { ...options, referrer: referrer })
    }
  },
  addHotjarMiddleWare () {
    window.analytics.ready(() => {
      window.analytics.addDestinationMiddleware('Hotjar', [this.hotjarMiddleWare])
    })
  },
  hotjarMiddleWare ({ payload, integration, next }) {
    payload.obj.source = 'assessment'

    // Remove PII data from the payload sent to Hotjar
    delete payload.obj.traits.email
    delete payload.obj.traits.firstName
    delete payload.obj.traits.gender
    delete payload.obj.traits.lastName

    next(payload)
  },
  orderCompleted: (data) => window.analytics.track('Order Completed', data),
  orderCompletedNewUser: (data) => window.analytics.track('Order Completed - New User', data),
  checkoutCompleted: (data) => window.analytics.track('checkout', { ...data, id: 1381425 }),
  reset: () => window.analytics.reset(),
  track: (eventTitle, eventData) => window.analytics.track(eventTitle, eventData),
  trackLink: (element, eventTitle, eventData) => window.analytics.trackLink(element, eventTitle, eventData)
}
